import { Link } from 'react-router-dom';
import type { Anime } from '@/mocks/anime';

interface AnimeCardProps {
  anime: Anime;
}

export default function AnimeCard({ anime }: AnimeCardProps) {
  return (
    <Link
      to={`/article/${anime.id}`}
      className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-300"
      data-product-shop
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={anime.coverImage}
          alt={`${anime.title} - 奶泡动漫高清番剧封面`}
          title={`${anime.title} ${anime.tags.join(' ')} - 奶泡动漫`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-3 left-3 flex flex-wrap gap-1.5">
          {anime.isHot && (
            <span className="px-2 py-0.5 bg-primary-500 text-background-50 text-xs font-medium rounded-md">
              热门
            </span>
          )}
          {anime.isNew && (
            <span className="px-2 py-0.5 bg-accent-500 text-background-50 text-xs font-medium rounded-md">
              新番
            </span>
          )}
        </div>
        <div className="absolute top-3 right-3">
          <span className="px-2 py-0.5 bg-background-950/60 backdrop-blur-sm text-background-50 text-xs font-semibold rounded-md">
            {anime.rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-background-950/80 to-transparent p-4">
          <div className="flex items-center gap-2 text-background-50 text-xs">
            <span className="flex items-center gap-1">
              <i className="ri-play-circle-line"></i>
              {anime.currentEpisode}/{anime.episodeCount}集
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {anime.views > 10000 ? `${(anime.views / 10000).toFixed(0)}万` : anime.views}
            </span>
          </div>
        </div>
      </div>
      <div className="p-3 md:p-4">
        <h3 className="text-sm md:text-base font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1.5">
          {anime.title}
        </h3>
        <p className="text-xs text-foreground-500 mb-2 line-clamp-1">{anime.titleJa}</p>
        <div className="flex items-center gap-2 flex-wrap">
          <span className="px-2 py-0.5 bg-secondary-100 text-secondary-700 text-xs rounded-md">
            {anime.category}
          </span>
          <span className={`px-2 py-0.5 text-xs rounded-md ${
            anime.status === '连载中'
              ? 'bg-accent-100 text-accent-700'
              : anime.status === '已完结'
              ? 'bg-background-200 text-foreground-600'
              : 'bg-background-100 text-foreground-500'
          }`}>
            {anime.status}
          </span>
        </div>
      </div>
    </Link>
  );
}